"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jwt_simple_1 = __importDefault(require("jwt-simple"));
const encodingKey = '1';
class Jwt {
    static encodeJwt(data) {
        return jwt_simple_1.default.encode(data, encodingKey);
    }
    static decodeJwt(accessToken) {
        return jwt_simple_1.default.decode(accessToken, encodingKey, true);
    }
}
exports.default = Jwt;
